// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.viewEvent_dashboard__lEdfy {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.viewEvent_dashboardContain__h15Id {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_dashboardContain__h15Id,
.viewEvent_bodythemedark__I\\+3nw .viewEvent_dashboard__lEdfy,
.viewEvent_bodythemedark__I\\+3nw .viewEvent_cont2__Ms5ke {
  background-Color: #0f1824;
}

.viewEvent_top_header__4\\+BI6 .viewEvent_top_header_inner__-y1Ms {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.viewEvent_cont2__Ms5ke {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.viewEvent_subLink__A2Vai svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.viewEvent_cst_vendr__VN2mH input {
  min-height: 35px !important;
}

.viewEvent_cst_vendr__VN2mH .viewEvent_form-control__LT4ox {
  background-color: #f5f6fa;
  border: none;
}

.viewEvent_footer__vnKs\\+ {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.viewEvent_bodythemelight__u4\\+Dx {
  background-color: #fff;
  padding-top: 90px;
}

.viewEvent_bodythemedark__I\\+3nw {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.viewEvent_headerthemelight__0NgEi {
  background-color: #fff;
}

.viewEvent_headerthemedark__asUPb {
  background-color: #132337;
}

.viewEvent_top_header__4\\+BI6 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.viewEvent_menuthemelight__3yTLe {
  background-color: #fff;
}

.viewEvent_menuthemedark__IQqKq {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.viewEvent_menulinklight__qPYP2 span {
  color: #666666 !important;
}

.viewEvent_menulinklight__qPYP2 a {
  color: #CBCBCB !important;
}

.viewEvent_menulinklight__qPYP2:hover span,
.viewEvent_menulinklight__qPYP2:hover a {
  color: #fff !important;
}

.viewEvent_menulinkdarkSelected__uGf4\\+ {
  background-color: #1c2e45;
  color: #3b82f6;
}

.viewEvent_menuthemelight__3yTLe .viewEvent_menulinklightSelected__QTbcs {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.viewEvent_menulinkdark__ncYbt {
  color: #92afd3 !important;
}

.viewEvent_menulinklight__qPYP2:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.viewEvent_menulinklight__qPYP2 .viewEvent_sub_arrow__Smu1l svg path {
  stroke: #CBCBCB !important;
}

.viewEvent_menulinklight__qPYP2:hover .viewEvent_sub_arrow__Smu1l svg path {
  stroke: #fff !important;
}

.viewEvent_menulinkdark__ncYbt .viewEvent_sub_arrow__Smu1l svg path {
  stroke: #92afd3 !important;
}

.viewEvent_menulinkdark__ncYbt:hover .viewEvent_sub_arrow__Smu1l svg path {
  stroke: #fff !important;
}

.viewEvent_menulinklight__qPYP2:hover svg path,
.viewEvent_menulinklightSelected__QTbcs svg path {
  fill: #fff !important;
}

.viewEvent_menulinkdark__ncYbt:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.viewEvent_headinglight__r7\\+86 {
  color: #60677e;
}

.viewEvent_headingdark__b4ZXE {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.viewEvent_searchboxlight__BxLpG {
  background-color: #fff;
  border: none;
}

.viewEvent_searchboxdark__3glrt {
  background-color: #132337;
  color: #fff;
  border: none;
}

.viewEvent_searchboxdark__3glrt::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.viewEvent_tableheadlight__58aYW {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.viewEvent_tableheadlight__58aYW th {
  color: #fff;
}

thead .viewEvent_tableheadlight__58aYW th:first-child,
thead .viewEvent_tableheaddark__JVL-i th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .viewEvent_tableheadlight__58aYW th:last-child,
thead .viewEvent_tableheaddark__JVL-i th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.viewEvent_table__U2AOw.viewEvent_table-borderless__elAYO {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.viewEvent_tableheaddark__JVL-i {
  background-color: #132337;
  color: #fff;
}

.viewEvent_table-borderless__elAYO tr:nth-child(even) {
  background-color: #F9FAFB;
}

.viewEvent_table-borderless__elAYO .viewEvent_left-section__8J6S5 {
  padding-top: 10px;
}

.viewEvent_tablebodylight__4K-7r td,
.viewEvent_tablebodydark__5A4Xg td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.viewEvent_tablebodylight__4K-7r {
  background-color: #fff;
}
.viewEvent_tablebodylight__4K-7r:hover {
  background-color: #fff;
  cursor: auto;
}

.viewEvent_tablebodydark__5A4Xg {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.viewEvent_tablebodydark__5A4Xg:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.viewEvent_paginationlight__UmLAp {
  color: #60677e !important;
  font-size: 13px !important;
}

.viewEvent_paginationdark__a3i\\+y {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.viewEvent_formthemelight__Ze3nG {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.viewEvent_formthemedark__lK6p8 {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.viewEvent_formthemedark__lK6p8 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.viewEvent_viewformlight__9gBFC {
  background-color: #f3f6f9;
}

.viewEvent_permissionboxlight__526zJ {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.viewEvent_permissionboxdark__NaGhX {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.viewEvent_errormsgclr__HepXq {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.viewEvent_graphclrlight__r6Y7z {
  background-color: #fff;
}

.viewEvent_graphclrdark__NVAn3 {
  background-color: #132337;
}

/* 
Counter theme
*/
#viewEvent_card1bglight__7gbEw {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#viewEvent_card1bgdark__nHAD4 {
  background: #392f28;
}

#viewEvent_card2bglight__V7isb {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#viewEvent_card2bgdark__JNW\\+M {
  background: #1c3238;
}

#viewEvent_card3bglight__2JFl5 {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#viewEvent_card3bgdark__\\+3cs1 {
  background: #3a2434;
}

#viewEvent_card4bglight__t9l8g {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#viewEvent_card4bgdark__DYPzQ {
  background: #2f264f;
}

#viewEvent_card1bgdark__nHAD4 a,
#viewEvent_card1bgdark__nHAD4 p,
#viewEvent_card2bgdark__JNW\\+M a,
#viewEvent_card2bgdark__JNW\\+M p,
#viewEvent_card3bgdark__\\+3cs1 a,
#viewEvent_card3bgdark__\\+3cs1 p,
#viewEvent_card4bgdark__DYPzQ a,
#viewEvent_card4bgdark__DYPzQ p {
  color: #fff;
}

/* 
Action button theme
*/
.viewEvent_actionbtnlight__sZC28 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.viewEvent_actionbtndark__QLqx7 {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.viewEvent_profiledropdownlight__tJP78 {
  background-color: #fff;
}

.viewEvent_profiledropdowndark__VyYZP {
  background-color: #151521;
}

.viewEvent_settingsection__j7OTM #viewEvent_addform__gATgO.viewEvent_formthemedark__lK6p8 .viewEvent_savebtn__QUnQN {
  background-color: #3b82f6;
  color: #fff;
}

#viewEvent_addform__gATgO.viewEvent_formthemedark__lK6p8 .viewEvent_savebtn__QUnQN {
  background-color: #3b82f6;
  color: #fff;
}

.viewEvent_profile_conatiner__RZB1y {
  border-radius: 5px !important;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_ag-theme-alpine__VBkF3 .viewEvent_ag-row__5ucnN {
  background: #000 !important;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_formbtn__dnubP {
  background-color: #3b82f6;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_formbtn__dnubP:hover {
  background-color: #2563eb;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_resetbtn__8NDLu {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.viewEvent_headingdark__b4ZXE span {
  background-color: #132337;
}

.viewEvent_resetbtn__8NDLu {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.viewEvent_resetbtn__8NDLu:hover,
.viewEvent_resetbtn__8NDLu:active,
.viewEvent_resetbtn__8NDLu:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.viewEvent_addBtn__qJCrv {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.viewEvent_addDltBtn__GQ0Rw {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.viewEvent_addbtnlight__Fqxsy {
  background-color: #38A169;
}

.viewEvent_addbtndark__z\\+pKv {
  background-color: #3b82f6;
}

.viewEvent_addbtndark__z\\+pKv:hover {
  background-color: #2563eb;
}

.viewEvent_formthemedark__lK6p8 label {
  color: #92afd3;
}

.viewEvent_addBtn__qJCrv svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.viewEvent_addBtn__qJCrv:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.viewEvent_cust_addBtn__NfSL9.viewEvent_addBtn__qJCrv svg {
  top: 2px;
}

.viewEvent_deleteBtn__tGdlm {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.viewEvent_deleteBtn__tGdlm:active,
.viewEvent_deleteBtn__tGdlm:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.viewEvent_deleteBtn__tGdlm svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.viewEvent_deleteBtn__tGdlm:hover,
.viewEvent_deleteBtn__tGdlm:active,
.viewEvent_deleteBtn__tGdlm:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.viewEvent_confirmBtn__hEG5N {
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  background-color: #131F43 !important;
}

.viewEvent_confirmBtn__hEG5N:active,
.viewEvent_confirmBtn__hEG5N:focus {
  background-color: #131F43 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.viewEvent_confirmBtn__hEG5N:hover,
.viewEvent_confirmBtn__hEG5N:active,
.viewEvent_confirmBtn__hEG5N:focus {
  background-color: #0f1824 !important;
}

.viewEvent_confirmBtn__hEG5N svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.viewEvent_delPopContainer__j3pDN .viewEvent_modal-body__PvqU9 {
  padding: 35px;
  text-align: center;
}

.viewEvent_delPopContainer__j3pDN .viewEvent_delet_icon__305sr {
  margin-bottom: 11px;
}

.viewEvent_delPopContainer__j3pDN p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.viewEvent_arrowback__2wJEZ svg {
  fill: #000;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_arrowback__2wJEZ {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_arrowback__2wJEZ svg {
  fill: #3b82f6;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_drpdwn_btn__gy-bQ {
  background-color: #132337;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_empname__0qGA9 {
  color: #92afd3 !important;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_navitemli__DIy49 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_tabnavli__KnpBi a.viewEvent_settingsgeneral__WJLSR,
.viewEvent_bodythemedark__I\\+3nw .viewEvent_tabnavli__KnpBi a.viewEvent_settingslinks__eLEV2:hover {
  background-color: #3b82f6;
  color: #fff;
}

.viewEvent_bodythemedark__I\\+3nw .viewEvent_tabnavli__KnpBi a.viewEvent_settingslinks__eLEV2 {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.viewEvent_headerthemedark__asUPb .viewEvent_dropdown_menu_contain__Swxik {
  background-color: #1c2e45;
  color: #fff;
}

.viewEvent_headerthemedark__asUPb .viewEvent_dropdown_menu_contain__Swxik ul li a,
.viewEvent_headerthemedark__asUPb .viewEvent_dropdown_menu_contain__Swxik .viewEvent_dropdown_item__k9mVP,
.viewEvent_headerthemedark__asUPb .viewEvent_dropdown_menu_contain__Swxik .viewEvent_dropdown_item__k9mVP h5 {
  color: #fff;
}

.viewEvent_headerthemedark__asUPb .viewEvent_dropdown_menu_contain__Swxik ul li a:hover,
.viewEvent_headerthemedark__asUPb .viewEvent_dropdown_menu_contain__Swxik .viewEvent_dropdown_item__k9mVP:hover {
  background-color: #132337;
  color: #fff;
}

.viewEvent_dropdown_item__k9mVP:active {
  background-color: #F5F6FA;
}

.viewEvent_profile_arrrow_dwn__qYEhf {
  stroke: #132337;
}

.viewEvent_headerthemedark__asUPb .viewEvent_profile_arrrow_dwn__qYEhf {
  stroke: #fff;
}

.viewEvent_dateinputbox1__eupje input,
.viewEvent_dateinputbox1__eupje span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.viewEvent_delPopContainer__j3pDN .viewEvent_modal-content__CH-WW {
  border-radius: 10px;
  min-width: 399px;
}

.viewEvent_larg_model__p-Gy0 .viewEvent_modal-dialog__DOz8g {
  max-width: 100% !important;
}

.viewEvent_larg_model__p-Gy0 .viewEvent_modal-content__CH-WW {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.viewEvent_larg_model__p-Gy0 .viewEvent_modal-header__9y8Rg {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .viewEvent_btn-primary__wEfyw:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.viewEvent_form-select__rTb5q {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .viewEvent_CustomTable_tableheadlight__HuHZw__m8nox th:first-child,
thead .viewEvent_CustomTable_tableheaddark__nwqb4__3yjm7 th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
}

@media only screen and (max-width: 1200px) {
  .viewEvent_tableheadlight__58aYW th {
    min-width: 170px;
  }
}
@media only screen and (max-width: 1024px) {
  .viewEvent_dashboard__lEdfy {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden;
  }
  .viewEvent_cont2__Ms5ke {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
  /*.tableheadlight th {
    min-width: 200px !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .viewEvent_sectionright__zJGop {
    float: unset !important;
  }
  .viewEvent_formthemelight__Ze3nG {
    padding: 10px 0 !important;
    box-shadow: none !important;
  }
  .viewEvent_dashboard__lEdfy {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .viewEvent_cont2__Ms5ke {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .viewEvent_bodythemelight__u4\\+Dx,
.viewEvent_bodythemedark__I\\+3nw {
    padding-top: 110px;
  }
  .viewEvent_delPopContainer__j3pDN .viewEvent_modal-content__CH-WW {
    min-width: 100%;
  }
  .viewEvent_delPopContainer__j3pDN .viewEvent_modal-body__PvqU9 {
    padding: 15px;
  }
  .viewEvent_larg_model__p-Gy0 .viewEvent_modal-content__CH-WW {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .viewEvent_exer_modal_contain__pclZV .viewEvent_modal-dialog__DOz8g {
    max-width: 1055px;
  }
  .viewEvent_delPopContainer__j3pDN .viewEvent_modal-dialog__DOz8g {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 200px;
  }*/
}
/* vk new changes */
.viewEvent_active_show_outer__XgLgS h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: "Plus Jakarta Sans", "Lufga", sans-serif !important;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 {
  width: 100%;
  display: block;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_img__-eKXd {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_img__-eKXd {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_img__-eKXd img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_cnt__6WhE7 {
  width: 100%;
  display: block;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_cnt__6WhE7 svg {
  flex-shrink: 0;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_cnt__6WhE7 .viewEvent_act_box_bdg__EJEaV {
  width: 100%;
  margin-bottom: 12px;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_cnt__6WhE7 .viewEvent_act_box_bdg__EJEaV span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_cnt__6WhE7 .viewEvent_act_box_bdg__EJEaV .viewEvent_sold__GFzmJ {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_cnt__6WhE7 h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_cnt__6WhE7 p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.viewEvent_active_show_outer__XgLgS .viewEvent_active_show_inner__HQ\\+G9 .viewEvent_act_box_cnt__6WhE7 p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}

/* vk new changes */
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_l__F2KnX img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: contain;
}
@media screen and (max-width: 767px) {
  .viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_l__F2KnX img {
    object-fit: contain;
    width: auto;
  }
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk {
  flex: 1 1;
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row__Y7ygd {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row__Y7ygd {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row__Y7ygd .viewEvent_attent_details_row_box__V9sjX {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row__Y7ygd .viewEvent_attent_details_row_box__V9sjX {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row__Y7ygd .viewEvent_attent_details_row_box__V9sjX {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row__Y7ygd .viewEvent_attent_details_row_box__V9sjX p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row__Y7ygd .viewEvent_attent_details_row_box__V9sjX h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row_last__FEDGo {
  margin-bottom: 0px !important;
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row_last__FEDGo.viewEvent_interesting_fact__uZktH {
  padding-top: 30px;
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row_last__FEDGo.viewEvent_interesting_fact__uZktH .viewEvent_attent_details_row_box__V9sjX {
  width: 100%;
}
.viewEvent_attent_details__zziLG .viewEvent_attent_details_inner__9JZ\\+Q .viewEvent_attent_details_inner_r__J0YYk .viewEvent_attent_details_row_last__FEDGo.viewEvent_interesting_fact__uZktH .viewEvent_attent_details_row_box__V9sjX h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.viewEvent_showbox_sec__T\\+Bw\\+ {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  align-items: stretch;
  width: 100%;
}
@media screen and (max-width: 500px) {
  .viewEvent_showbox_sec__T\\+Bw\\+ {
    grid-template-columns: 1fr;
  }
}

.viewEvent_show_box_main__nysLV {
  margin: 10px 0px;
  width: 100%;
}
.viewEvent_show_box_main__nysLV .viewEvent_show_box__cjhCz {
  min-height: 600px;
  width: 100%;
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .viewEvent_show_box_main__nysLV .viewEvent_show_box__cjhCz {
    min-height: 500px;
  }
}
.viewEvent_show_box_main__nysLV .viewEvent_show_box__cjhCz .viewEvent_active_show_inner__HQ\\+G9 {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.viewEvent_show_box_main__nysLV .viewEvent_show_box__cjhCz .viewEvent_act_box_img__-eKXd {
  flex-shrink: 0;
}
.viewEvent_show_box_main__nysLV .viewEvent_show_box__cjhCz .viewEvent_act_box_cnt__6WhE7 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.viewEvent_show_box_main__nysLV .viewEvent_show_box__cjhCz img {
  max-height: 400px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 767px) {
  .viewEvent_show_box_main__nysLV .viewEvent_show_box__cjhCz img {
    max-height: 300px !important;
  }
}
.viewEvent_show_box_main__nysLV .viewEvent_show_box__cjhCz:last-child {
  margin-right: 0;
}
.viewEvent_show_box_main__nysLV .viewEvent_no_show_box__r2uLC {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .viewEvent_show_box_main__nysLV .viewEvent_no_show_box__r2uLC {
    width: 250px !important;
  }
}
.viewEvent_show_box_main__nysLV .viewEvent_no_show_box__r2uLC img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .viewEvent_show_box_main__nysLV .viewEvent_no_show_box__r2uLC img {
    max-height: 350px !important;
  }
}
.viewEvent_show_box_main__nysLV .viewEvent_no_show_box__r2uLC h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .viewEvent_show_box_main__nysLV .viewEvent_no_show_box__r2uLC h6 {
    font-size: 20px;
  }
}

.viewEvent_attent_flex__JxOG9 {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.viewEvent_attent_flex__JxOG9 h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.viewEvent_eventcard_sec__\\+PWKR {
  min-height: 533px;
  width: 100%;
  padding: 30px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
}

.viewEvent_event_card_div__ON38S {
  height: 225px;
  overflow-y: hidden;
  min-height: 225px;
  border-radius: 5px;
}

.viewEvent_eventcard_sec__\\+PWKR img {
  width: 100%;
  height: auto;
  flex-shrink: 0;
}

.viewEvent_eventnamep__xuh7y {
  color: #727272;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 22px;
  margin-bottom: 10px;
}

.viewEvent_electroh5__YFpBx {
  color: #131F43;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.viewEvent_location__9W739 {
  color: #727272;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 24px;
  margin-bottom: 6px;
}

.viewEvent_gala__oLfHg {
  color: #131F43;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 6px;
}

.viewEvent_guild__K-lW7 {
  color: #555;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 6px;
}

.viewEvent_eventcard_sec__\\+PWKR img {
  border-radius: 5px;
}

.viewEvent_eventcard_sec__\\+PWKR input {
  width: 100%;
  height: 54px;
  flex-shrink: 0;
  border-radius: 10px;
  background: rgba(43, 193, 85, 0.1);
  border: none;
}

.viewEvent_copyclip__sfnNI {
  position: relative;
  margin-top: 24px;
}

.viewEvent_copyclip__sfnNI svg {
  position: absolute;
  right: 15px;
  top: 10px;
  background: #fff;
  height: 35px;
  width: 35px;
  padding: 9px;
  border-radius: 50%;
}

.viewEvent_copyclip__sfnNI input {
  padding: 0 15px;
  color: #2BC155;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.viewEvent_profile_view_container__mfwrE {
  padding: 25px 0 !important;
}
@media screen and (max-width: 768px) {
  .viewEvent_profile_view_container__mfwrE {
    padding: 15px;
  }
}

.viewEvent_eventcategorybox__TSIdH {
  width: 100%;
  height: 258px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #FFF;
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 80px;
  overflow: hidden;
  position: relative;
}
@media screen and (max-width: 767px) {
  .viewEvent_eventcategorybox__TSIdH {
    height: 200px;
  }
}

.viewEvent_eventcategorybox__TSIdH svg {
  z-index: 1;
  position: relative;
}

.viewEvent_bg_icons_evnt__2MbS6 {
  position: absolute;
  left: -24px;
  bottom: -24px;
  width: 120px;
  height: 120px;
  z-index: 0;
  pointer-events: none;
}

.viewEvent_sm_icon__mxSJz {
  position: absolute !important;
  bottom: 40px;
  left: 25px;
  width: 42px !important;
  height: 42px !important;
}

.viewEvent_bg_icons_evnt__2MbS6 svg {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
}

.viewEvent_formbtncalloff__SLOxt {
  padding: 13px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #F94747 !important;
  color: var(--white, #FFF);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  align-items: center;
}

.viewEvent_formbtncalloff__SLOxt:after {
  content: url(http://localhost:3000/static/media/submit.66993ad….svg);
  display: block;
  position: absolute;
  left: 30px;
  top: -1px;
  pointer-events: none;
}

.viewEvent_formbtnedit__gtnuP {
  padding: 13px 210px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #FF9330 !important;
  color: var(--white, #FFF);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  align-items: center;
}

.viewEvent_txt__A5qjW {
  z-index: 1;
}

.viewEvent_txt__A5qjW p {
  color: #414141;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.viewEvent_txt__A5qjW h5 {
  color: #1C1C1C;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 16px;
}

.viewEvent_vendorsty__EmXW1 {
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 44px 0 24px 0 !important;
}

.viewEvent_vendorssec__ue23e {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #FFF;
  padding: 30px 24px;
}

.viewEvent_vendorssec__ue23e img {
  width: 82px;
  height: 82px;
  flex-shrink: 0;
}

.viewEvent_vendors_box__ELQBK p {
  display: flex;
  padding: 5px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(253, 152, 0, 0.2) !important;
  color: var(--Primary-old, var(--Primary, #FD9800));
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px; /* 120% */
  letter-spacing: 1px;
  text-transform: uppercase;
}

.viewEvent_vendors_box__ELQBK h5 {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 4px !important;
}

.viewEvent_vendors_box__ELQBK h6 {
  color: var(--Black, #0B0D0F);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 18px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/shows/viewEvent.module.scss","webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAmDC;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,gBAAA;ADvEH;;AC0EC;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ADvEH;;AC0EC;;;EAGE,yBAnEoB;ADJvB;;AC0EC;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ADvEH;;AC0EC;;CAAA;AAIA;EACE,wBAzCU;EA0CV,UAzCS;EA0CT,kBAAA;EACA,aAjDiB;EAkDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ADrEH;;AC2EC;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADxEH;;AC6EC;EACE,2BAAA;AD1EH;;AC6EC;EACE,yBAAA;EACA,YAAA;AD1EH;;AC8EC;EACE,YAAA;AD3EH;;AC8EC;EACE,sBA9GY;ADmCf;;AC8EC;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AD3EH;;AC8EC;EACE,yBArIgB;EAsIhB,iBAAA;AD3EH;;AC8EC;;CAAA;AAGA;EACE,sBAlIY;ADuDf;;AC8EC;EACE,yBAjJgB;ADsEnB;;AC8EC;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AD3EH;;AC8EC;;CAAA;AAGA;EACE,sBAvJY;AD4Ef;;AC8EC;EACE,yBAtKgB;AD2FnB;;AC8EC;;CAAA;AAGA;EACE,yBAAA;AD3EH;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;;EAEE,sBAAA;AD3EH;;AC8EC;EACE,yBAxLsB;EAyLtB,cAnMkB;ADwHrB;;AC8EC;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AD3EH;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;EACE,sBAAA;EACA,oCAAA;AD3EH;;AC8EC;EACE,0BAAA;AD3EH;;AC8EC;EACE,uBAAA;AD3EH;;AC8EC;EACE,0BAAA;AD3EH;;AC8EC;EACE,uBAAA;AD3EH;;AC8EC;;EAEE,qBAAA;AD3EH;;AC8EC;EACE,yBAjOsB;EAkOtB,WAzNY;AD8If;;AC8EC;;CAAA;AAGA;EACE,cA7Ne;ADkJlB;;AC8EC;EACE,cAjOe;ADsJlB;;AC8EC;;CAAA;AAGA;EACE,sBA3OY;EA4OZ,YAAA;AD3EH;;AC8EC;EACE,yBA3PgB;EA4PhB,WAjPY;EAkPZ,YAAA;AD3EH;;AC8EC;EACE,cAnPe;ADwKlB;;AC8EC;;CAAA;AAGA;EACE,yBA3Sc;EA4Sd,8BAAA;AD3EH;;AC8EC;EACE,WAlQY;ADuLf;;AC8EC;;EAEE,0BAAA;AD3EH;;AC8EC;;EAEE,0BAAA;AD3EH;;AC8EC;EACE,kBAAA;AD3EH;;AC8EC;EACE,kBAAA;AD3EH;;AC8EC;EACE,oCAAA;EACA,gCAAA;AD3EH;;AC8EC;EACE,yBArRkB;EAsRlB,WA9RY;ADmNf;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;EACE,iBAAA;AD3EH;;AC8EC;;EAEE,+BAAA;EACA,iBAAA;AD3EH;;AC8EC;EACE,sBAhTY;ADqOf;AC6EG;EACE,sBAnTU;EAoTV,YAAA;AD3EL;;AC+EC;EACE,0CAAA;EACA,cAvTe;AD2OlB;AC8EG;EACE,yCAAA;EACA,eAAA;AD5EL;;ACgFC;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AD7EH;;ACgFC;EACE,yBAAA;EACA,0BAAA;AD7EH;;ACgFC;;CAAA;AAGA;EACE,sBAnVY;EAoVZ,yBAAA;EACA,qDAAA;AD7EH;;ACgFC;EACE,yBAjVkB;EAkVlB,yBAAA;EACA,eAAA;AD7EH;AC+EG;EACE,cA3Va;AD8QlB;;ACkFC;;CAAA;AAGA;EACE,yBA1WgB;AD2RnB;;ACkFC;EACE,yBAAA;EACA,yBAAA;AD/EH;;ACkFC;EACE,yBA1XoB;EA2XpB,yBAAA;AD/EH;;ACkFC;EACE,UAAA;EACA,eAAA;EACA,eAAA;AD/EH;;ACkFC;;CAAA;AAGA;EACE,sBA9XY;AD+Sf;;ACkFC;EACE,yBA1XkB;AD2SrB;;ACmFC;;CAAA;AAGA;EACE,iGAAA;EACA,sBA3YY;AD2Tf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBApZY;ADoUf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBA7ZY;AD6Uf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBAtaY;ADsVf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;;;;;;;;EAQE,WArbY;ADqWf;;ACmFC;;CAAA;AAGA;EACE,qCAAA;ADhFH;;ACmFC;EACE,cA7be;AD6WlB;;ACoFC;;CAAA;AAGA;EACE,sBAAA;ADjFH;;ACoFC;EACE,yBAAA;ADjFH;;ACoFC;EACE,yBAjekB;EAkelB,WAjdY;ADgYf;;ACoFC;EACE,yBAtekB;EAuelB,WAtdY;ADqYf;;ACoFC;EACE,6BAAA;ADjFH;;ACoFC;EACE,2BAAA;ADjFH;;ACoFC;EACE,yBAnfkB;ADkarB;;ACoFC;EACE,yBAtfwB;ADqa3B;;ACoFC;EACE,WA1eY;EA2eZ,6BAAA;EACA,yBAAA;ADjFH;;ACqFC;EACE,yBA5fgB;AD0anB;;ACqFC;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ADlFH;;ACqFC;;;EAGE,oCAAA;EACA,sBAAA;ADlFH;;ACqFC;EACE,gBAAA;EACA,YAAA;EACA,WAxgBY;EAygBZ,yBAriBY;EAsiBZ,YAAA;EACA,eAAA;EACA,gBAhkBc;AD8ejB;;ACqFE;EACC,gBAAA;EACA,YAAA;EACA,WAlhBY;EAmhBZ,yBA/iBY;EAgjBZ,YAAA;EACA,eAAA;EACA,gBA1kBc;ADwfjB;;ACqFC;EACE,yBAtjBY;ADoef;;ACqFC;EACE,yBA/iBkB;AD6drB;;ACqFC;EACE,yBAljBwB;ADge3B;;ACqFC;EACE,cAxjBiB;ADsepB;;ACsFC;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ADnFH;;ACsFC;EACE,WAjjBY;EAkjBZ,yBA9kBY;EA+kBZ,YAAA;ADnFH;;ACsFC;EACE,QAAA;ADnFH;;ACuFC;EACE,gBAAA;EACA,YAAA;EACA,yBAnlBW;EAolBX,WA/jBY;EAgkBZ,eAAA;EACA,gBArnBc;EAsnBd,YAAA;ADpFH;;ACuFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADpFH;;ACuFC;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADpFH;;ACuFC;;;EAGE,yBA1mBW;EA2mBX,WAtlBY;EAulBZ,YAAA;ADpFH;;ACuFC;EACC,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,oCAAA;ADpFF;;ACuFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADpFH;;ACuFC;;;EAGE,oCAAA;ADpFH;;ACuFC;EACC,kBAAA;EACA,kBAAA;EACA,SAAA;ADpFF;;ACyFC;EACE,aAAA;EACA,kBAAA;ADtFH;;ACyFC;EACE,mBAAA;ADtFH;;ACyFC;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ADtFH;;ACyFC;EACE,UAAA;ADtFH;;ACyFC;EACE,yCA7pBc;EA8pBd,cAlqBkB;AD4kBrB;;ACyFC;EACE,aAtqBkB;ADglBrB;;ACyFC;EACE,yBAlqBgB;AD4kBnB;;ACyFC;EACE,yBAAA;ADtFH;;ACyFC;EACE,6BAAA;EACA,yBAAA;EACA,WAjqBY;AD2kBf;;ACyFC;;EAEE,yBAvrBkB;EAwrBlB,WAvqBY;ADilBf;;ACyFC;EACE,6BAAA;EACA,yBAAA;EACA,WA7qBY;ADulBf;;ACyFC;EACE,yBA1rBsB;EA2rBtB,WAlrBY;AD4lBf;;ACyFC;;;EAGE,WAxrBY;ADkmBf;;ACyFC;;EAEE,yBAxsBgB;EAysBhB,WA9rBY;ADwmBf;;ACyFC;EACE,yBAjvBO;AD2pBV;;ACyFC;EACE,eAjtBgB;AD2nBnB;;ACyFC;EACE,YA1sBY;ADonBf;;ACyFC;;EAEE,sBAAA;ADtFH;;ACyFC,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AD1FH;;AC6FC;EACE,0BAAA;AD1FH;;AC6FC;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AD1FH;;AC6FC;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AD1FH;;AC6FC;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AD1FH;;AC6FC;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AD1FH;;AC6FC;;EAEE,0BAAA;EACA,aAAA;AD1FH;;AC6FC;EACE,kBAAA;AD1FH;;AC6FC;EACE;IACE,gBAAA;ED1FH;AACF;AC6FC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kBAAA;ED3FH;EC8FC;IACE,2BAAA;IACA,gBAAA;ED5FH;AACF;AC+FC;EACE;;IAAA;EAGA;;IAAA;AD3FH;ACgGC;EACE;IACE,uBAAA;ED9FH;ECgGD;IACE,0BAAA;IACA,2BAAA;ED9FD;ECgGC;IACE,6BAAA;ED9FH;AACF;ACiGC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;ED/FH;ECkGC;;IAEE,kBAAA;EDhGH;ECmGC;IACE,eAAA;EDjGH;ECoGC;IACE,aAAA;EDlGH;ECqGC;IACE,8BAAA;IACA,aAAA;EDnGH;AACF;ACsGC;EACE;IACE,iBAAA;EDpGH;ECuGC;IACE,gBAAA;EDrGH;ECwGC;;IAAA;ADpGH;ACyGC,mBAAA;AAGA;EACE,iCAAA;EACA,gEAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADzGH;AC4GG;EACE,WAAA;EACA,cAAA;AD1GL;AC4GK;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AD1GP;AC2GO;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;EDxGP;AACF;ACyGO;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ADvGT;AC2GK;EACE,WAAA;EACA,cAAA;ADzGP;AC0GC;EACC,cAAA;ADxGF;AC0GO;EACE,WAAA;EACA,mBAAA;ADxGT;AC0GS;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADxGX;AC2GS;EACE,kFAAA;ADzGX;AC8GO;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AD5GT;AC+GO;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AD7GT;AC+GS;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AD7GX;;ACoHC,mBAAA;AAEE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ADlHL;ACoHK;EATF;IAUI,yBAAA;EDjHL;AACF;ACmHK;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EDhHL;AACF;ACmHO;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;ADjHT;ACkHS;EALF;IAMG,mBAAA;IACA,WAAA;ED/GR;AACF;ACmHK;EACE,SAAA;ADjHP;ACmHO;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ADjHT;ACmHS;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;EDhHT;AACF;ACkHS;EACE,SAAA;EACA,UAAA;ADhHX;ACkHW;EAJF;IAKI,gCAAA;IACA,sBAAA;ED/GX;AACF;ACiHW;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;ED9GX;AACF;ACgHW;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD9Gb;ACiHW;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AD/Gb;ACoHM;EACE,6BAAA;ADlHR;ACmHQ;EACE,iBAAA;ADjHV;ACkHU;EACE,WAAA;ADhHZ;ACiHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AD/Gd;;ACuHC;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;ADpHH;ACqHG;EANF;IAOI,0BAAA;EDlHH;AACF;;ACoHC;EACE,gBAAA;EACA,WAAA;ADjHH;ACmHG;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;ADjHL;ACmHK;EATF;IAUI,iBAAA;EDhHL;AACF;ACkHK;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ADhHP;ACmHK;EACE,cAAA;ADjHP;ACoHK;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;ADlHP;ACqHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ADnHP;ACqHO;EANF;IAOI,4BAAA;EDlHP;AACF;ACqHK;EACE,eAAA;ADnHP;ACuHG;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ADrHL;ACuHK;EALF;IAMI,uBAAA;EDpHL;AACF;ACsHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ADpHP;ACsHO;EALF;IAMI,4BAAA;EDnHP;AACF;ACqHK;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ADnHP;ACoHO;EARF;IASI,eAAA;EDjHP;AACF;;ACwHC;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ADrHH;ACuHG;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ADrHL;;AAjlCA;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AAolCF;;AAllCA;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAqlCF;;AAnlCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAslCF;;AAplCA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAulCF;;AArlCA;EACE,cAAA;EACF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAwlCA;;AAtlCA;EACE,cAAA;EACF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAylCA;;AAvlCA;EACE,cAAA;EACF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA0lCA;;AAxlCA;EACE,WAAA;EACF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA2lCA;;AAxlCA;EACE,kBAAA;AA2lCF;;AAzlCA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;EACA,YAAA;AA4lCA;;AA1lCA;EACA,kBAAA;EACA,gBAAA;AA6lCA;;AA3lCA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA8lCA;;AA5lCA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA+lCA;;AA7lCA;EACE,0BAAA;AAgmCF;AA/lCE;EAFF;IAGQ,aAAA;EAkmCN;AACF;;AAhmCA;EAEE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAkmCF;AAjmCE;EAbF;IAcI,aAAA;EAomCF;AACF;;AAlmCA;EACE,UAAA;EACA,kBAAA;AAqmCF;;AAnmCA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;AAsmCF;;AApmCA;EACE,6BAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;AAumCF;;AArmCA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;AAwmCF;;AAtmCA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAymCA;;AAvmCA;EACE,oEAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;AA0mCF;;AAxmCA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA2mCA;;AAxmCA;EACE,UAAA;AA2mCF;;AAxmCA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA2mCA;;AAzmCA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA4mCA;;AA1mCA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AA6mCA;;AA3mCA;EACA,aAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AA8mCA;;AA5mCA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA+mCA;;AA7mCA;EAEA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6CAAA;EACA,kDAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,mBAAA;EACA,yBAAA;AA+mCA;;AA7mCA;EAEA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AA+mCA;;AA7mCA;EAEA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;AA+mCA","sourcesContent":["@import \"../../styles/Variables/Variables.scss\";\n\n.eventcard_sec{\n  min-height: 533px;\n  width: 100%;\n  padding: 30px;\n  border-radius: 5px;\n  background: #FFF;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n}\n.event_card_div{\n  height: 225px;\n  overflow-y: hidden;\n  min-height: 225px;\n  border-radius: 5px;\n}\n.eventcard_sec img{\n  width: 100%;\n  height: auto;\n  flex-shrink: 0;\n}\n.eventnamep{\n  color: #727272;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-top: 22px;\n  margin-bottom: 10px;\n}\n.electroh5{\n  color: #131F43;\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.location{\n  color: #727272;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nmargin-top: 24px;\nmargin-bottom: 6px;\n}\n.gala{\n  color: #131F43;\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nmargin-bottom: 6px;\n}\n.guild{\n  color: #555;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\nmargin-bottom: 6px;\n\n}\n.eventcard_sec img{\n  border-radius: 5px;\n}\n.eventcard_sec input{\nwidth: 100%;\nheight: 54px;\nflex-shrink: 0;\nborder-radius: 10px;\nbackground: rgba(43, 193, 85, 0.10);\nborder: none;\n}\n.copyclip{\nposition: relative;\nmargin-top: 24px;\n}\n.copyclip svg{\nposition: absolute;\nright: 15px;\ntop: 10px;\nbackground: #fff;\nheight: 35px;\nwidth: 35px;\npadding: 9px;\nborder-radius: 50%;\n}\n.copyclip input{\npadding: 0 15px;\ncolor: #2BC155;\nfont-size: 20px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.profile_view_container{\n  padding: 25px 0 !important;\n  @media screen and (max-width:768px) {\n        padding: 15px;\n    }\n}\n.eventcategorybox\n{\n  width: 100%;\n  height: 258px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #FFF;\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 80px;\n  overflow: hidden;\n  position: relative;\n  @media screen and (max-width:767px) {\n    height: 200px;\n  }\n}\n.eventcategorybox svg {\n  z-index: 1;\n  position: relative;\n}\n.bg_icons_evnt {\n  position: absolute;\n  left: -24px;\n  bottom: -24px;\n  width: 120px;\n  height: 120px;\n  z-index: 0;\n  pointer-events: none;\n}\n.sm_icon {\n  position: absolute !important;\n  bottom: 40px;\n  left: 25px;\n  width: 42px !important;\n  height: 42px !important;\n}\n.bg_icons_evnt svg{\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: contain;\n}\n.formbtncalloff{\npadding: 13px 10px;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nborder-radius: 5px;\nbackground: #F94747 !important;\ncolor: var(--white, #FFF);\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 600; \nline-height: normal;\nalign-items: center;\n}\n.formbtncalloff:after{\n  content: url(http://localhost:3000/static/media/submit.66993ad….svg);\n  display: block;\n  position: absolute;\n  left: 30px;\n  top: -1px;\n  pointer-events: none;\n}\n.formbtnedit{\npadding: 13px 210px;\njustify-content: center;\nalign-items: center;\ngap: 10px;\nborder-radius: 5px;\nbackground: #FF9330 !important;\ncolor: var(--white, #FFF);\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nalign-items: center;\n}\n\n.txt {\n  z-index: 1;\n}\n\n.txt p{\ncolor: #414141;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n.txt h5{\ncolor: #1C1C1C;\nfont-size: 22px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nmargin-top: 16px;\n}\n.vendorsty{\ncolor: #000;\nfont-size: 20px;\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\nmargin: 44px 0 24px 0 !important;\n}\n.vendorssec{\ndisplay: flex;\ngap: 10px;\nflex-shrink: 0;\nborder-radius: 5px;\nbackground: #FFF;\npadding: 30px 24px;\n}\n.vendorssec img{\nwidth: 82px;\nheight: 82px;\nflex-shrink: 0;\n}\n.vendors_box p\n{\ndisplay: flex;\npadding: 5px 16px;\njustify-content: center;\nalign-items: center;\nborder-radius: 100px;\nbackground: rgba(253, 152, 0, 0.20) !important;\ncolor: var(--Primary-old, var(--Primary, #FD9800));\ntext-align: center;\nfont-size: 10px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 12px; /* 120% */\nletter-spacing: 1px;\ntext-transform: uppercase;\n}\n.vendors_box h5\n{\ncolor: #000;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nmargin-bottom: 4px !important;\n}\n.vendors_box h6\n{\ncolor: var(--Black, #0B0D0F);\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\nmargin-bottom: 18px !important;\n}\n","/* \nscss\n */\n $font-regular: 400;\n $font-medium: 500;\n $font-semiBold: 600;\n $font-bold: 700;\n $font-extraBold: 800;\n $font-black: 900;\n \n $mainBg: #F5F6FA;\n $primary-color: #131F43;\n $icon-bgcolor: #F6F6F6;\n $text-graycolor: #727272;\n $cardIcon1-bg: #F3F4F8;\n $cardIcon1-darkbg: #30231a;\n $cardIcon1-darkbg-icon: #9d785f;\n $cardIcon2-bg: #FAF4FB;\n $cardIcon2-darkbg: #13252a;\n $cardIcon2-darkbg-icon: #3b606a;\n $cardIcon3-bg: #FAF7F3;\n $cardIcon3-darkbg: #2c1a27;\n $cardIcon3-darkbg-icon: #6c4863;\n $cardIcon4-bg: #F5F9FC;\n $cardIcon4-darkbg: #241d3e;\n $cardIcon4-darkbg-icon: #5f538b;\n $cardIcon2-color: #AC44BB;\n $cardIcon3-color: #D69A5F;\n $cardIcon4-color: #176CA5;\n $green-color: #38A169;\n $darkGreen-color: #207a4a;\n $placeholder-color: #666666;\n $profile-dark-text: #181818;\n $heading : #0B0D0F;\n $light-gray : #999999;\n $menu_icon : #CBCBCB;\n $red-color : #F94747;\n $red-hover : #960101;\n $dark-active-blue : #3b82f6;\n $dark-light-blue : #92afd3;\n $addBtn-dark-blue : #3b82f6;\n $addBtn-dark-blue-hover : #2563eb;\n $backBtn-dark : #3b82f633;\n \n \n \n $darkTheme_blue : #132337;\n $darkTheme_darkBlue : #0f1824;\n $darkTheme_selectBlue : #1c2e45;\n $darkTheme_updateBtn : #0a2574;\n \n /* \n Body Theme Color\n  */\n $lightthemecolor: #f3f6f9;\n $darkthemecolor: #151521;\n \n $white-color: #fff;\n $black-color: #1d1d1d;\n $fullBlack-color: #1d1d1d;\n $lightthemetext: #60677e;\n \n /* \n Dark Theme Colors\n */\n $primarydark-color: #132337;\n \n /* \n Button Theme\n */\n $primary-btncolor: #131F43;\n $secondary-btncolor: rgba(37, 105, 109, 0.864);\n \n $tableheadlightbg: #e9eaf0;\n \n \n /* \n Max Dashboard scss\n */\n $dashboardwidth: calc(100% - 320px);\n $dashboardposition: absolute;\n $dashboardleft: 290px;\n $dashboardpadding: 30px;\n \n /* \n Min Dashboard scss\n */\n $dashwidth: calc(100% - 50px);\n $dashleft: 50px;\n \n /* \n Max Dashboard scss\n */\n \n .dashboard {\n   width: $dashboardwidth;\n   position: relative;\n   left: $dashboardleft;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   min-height: auto !important;\n   background-color: $mainBg;\n   overflow-y: auto;\n }\n \n .dashboardContain {\n   width: calc(100% - 320px);\n   background-Color: $mainBg;\n   border-radius: 8px;\n }\n \n .bodythemedark .dashboardContain,\n .bodythemedark .dashboard,\n .bodythemedark .cont2 {\n   background-Color: $darkTheme_darkBlue;\n }\n \n .top_header .top_header_inner {\n   background-color: transparent;\n   height: auto;\n   overflow-y: unset;\n }\n \n /* \n Min Dashboard scss\n */\n \n .cont2 {\n   width: $dashwidth;\n   left: $dashleft;\n   position: relative;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   background: $mainBg;\n   /*height: calc(100vh - 160px);*/\n   height: 100%;\n   min-height: auto !important;\n   overflow-y: auto;\n   /* \n background-Color: $dashboardbackgroundColor;\n   padding-bottom: 8%;\n */\n }\n \n .subLink svg {\n   position: relative;\n   top: -2px;\n   left: -7px;\n }\n \n \n \n .cst_vendr input {\n   min-height: 35px !important;\n }\n \n .cst_vendr .form-control {\n   background-color: #f5f6fa;\n   border: none;\n }\n \n \n .footer {\n   height: 70px;\n }\n \n body {\n   background-color: $white-color;\n }\n \n /* \n THEME CHANGE\n */\n .bodythemelight {\n   background-color: $white-color;\n   padding-top: 90px;\n }\n \n .bodythemedark {\n   background-color: $darkTheme_blue;\n   padding-top: 90px;\n }\n \n /* \n Header Navbar Theme\n */\n .headerthemelight {\n   background-color: $white-color;\n }\n \n .headerthemedark {\n   background-color: $darkTheme_blue;\n }\n \n .top_header {\n   min-height: 90px;\n   display: flex;\n   align-items: center;\n   position: fixed;\n   width: 100%;\n   z-index: 2;\n   top: 0;\n }\n \n /* \n LEFT MENU THEME CHANGE\n */\n .menuthemelight {\n   background-color: $white-color;\n }\n \n .menuthemedark {\n   background-color: $darkTheme_blue;\n }\n \n /* \n LEFT MENU LINKS THEME CHANGE\n */\n .menulinklight span {\n   color: $placeholder-color !important;\n }\n \n .menulinklight a {\n   color: $menu_icon !important;\n }\n \n .menulinklight:hover span,\n .menulinklight:hover a {\n   color: $white-color !important;\n }\n \n .menulinkdarkSelected {\n   background-color: $darkTheme_selectBlue;\n   color: $dark-active-blue;\n }\n \n .menuthemelight .menulinklightSelected {\n   /*background-color: $lightthemecolor;*/\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinkdark {\n   color: $dark-light-blue !important;\n }\n \n .menulinklight:hover {\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinklight .sub_arrow svg path {\n   stroke: $menu_icon !important;\n }\n \n .menulinklight:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinkdark .sub_arrow svg path {\n   stroke: $dark-light-blue !important;\n }\n \n .menulinkdark:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinklight:hover svg path,\n .menulinklightSelected svg path {\n   fill: #fff !important;\n }\n \n .menulinkdark:hover {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n /* \n BODY HEADERS\n */\n .headinglight {\n   color: $lightthemetext;\n }\n \n .headingdark {\n   color: $lightthemetext;\n }\n \n /* \n SEARCH BOX THEME COLOR\n */\n .searchboxlight {\n   background-color: $white-color;\n   border: none;\n }\n \n .searchboxdark {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n   border: none;\n }\n \n .searchboxdark::placeholder {\n   color: $lightthemetext;\n }\n \n /* \n CUSTOM TABLE THEME COLOR\n */\n .tableheadlight {\n   background-color: $primary-color;\n   border-radius: 5px 5px 0px 0px;\n }\n \n .tableheadlight th {\n   color: $white-color;\n }\n \n thead .tableheadlight th:first-child,\n thead .tableheaddark th:first-child {\n   border-radius: 5px 0 0 0px;\n }\n \n thead .tableheadlight th:last-child,\n thead .tableheaddark th:last-child {\n   border-radius: 0 5px 0px 0;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n td:last-child {\n   border-radius: 0px;\n }\n \n table.table.table-borderless {\n   border-collapse: separate !important;\n   border-spacing: 0 0px !important;\n }\n \n .tableheaddark {\n   background-color: $primarydark-color;\n   color: $white-color;\n }\n \n .table-borderless tr:nth-child(even) {\n   background-color: #F9FAFB;\n }\n \n .table-borderless .left-section {\n   padding-top: 10px;\n }\n \n .tablebodylight td,\n .tablebodydark td {\n   padding: 0.5rem 1rem !important;\n   line-height: 45px;\n }\n \n .tablebodylight {\n   background-color: $white-color;\n \n   &:hover {\n     background-color: $white-color;\n     cursor: auto;\n   }\n }\n \n .tablebodydark {\n   /* background-color: $primarydark-color; */\n   color: $lightthemetext;\n \n   &:hover {\n     background-color: rgba(33, 150, 243, 0.1);\n     cursor: pointer;\n   }\n }\n \n /* \n PAGINATION THEME COLOR\n */\n .paginationlight {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n .paginationdark {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n /* \n SETTING FORM THEME COLOR\n */\n .formthemelight {\n   background-color: $white-color;\n   color: $black-color !important;\n   box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n }\n \n .formthemedark {\n   background-color: $primarydark-color;\n   color: $lightthemetext !important;\n   font-size: 14px;\n \n   ::placeholder {\n     color: $lightthemetext;\n   }\n }\n \n \n /* \n VIEW FORM DETAILS BOX THEME COLOR\n */\n .viewformlight {\n   background-color: $lightthemecolor;\n }\n \n .permissionboxlight {\n   background-color: #f8f9fa;\n   border: 1px solid #dee2e6;\n }\n \n .permissionboxdark {\n   background-color: $darkTheme_darkBlue;\n   border: solid 1px #242434;\n }\n \n .errormsgclr {\n   color: red;\n   font-size: 14px;\n   margin-top: 5px;\n }\n \n /* \n Graph theme\n */\n .graphclrlight {\n   background-color: $white-color;\n }\n \n .graphclrdark {\n   background-color: $primarydark-color;\n }\n \n \n /* \n Counter theme\n */\n #card1bglight {\n   /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card1bgdark {\n   background: #392f28;\n }\n \n #card2bglight {\n   /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card2bgdark {\n   background: #1c3238;\n }\n \n #card3bglight {\n   /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card3bgdark {\n   background: #3a2434;\n }\n \n #card4bglight {\n   /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card4bgdark {\n   background: #2f264f;\n }\n \n #card1bgdark a,\n #card1bgdark p,\n #card2bgdark a,\n #card2bgdark p,\n #card3bgdark a,\n #card3bgdark p,\n #card4bgdark a,\n #card4bgdark p {\n   color: $white-color;\n }\n \n /* \n Action button theme\n */\n .actionbtnlight {\n   color: #46475bde;\n }\n \n .actionbtndark {\n   color: $lightthemetext;\n }\n \n \n /* \n profile dropdowntheme\n */\n .profiledropdownlight {\n   background-color: #fff;\n }\n \n .profiledropdowndark {\n   background-color: #151521;\n }\n \n .settingsection #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .profile_conatiner {\n   border-radius: 5px !important;\n }\n \n .bodythemedark .ag-theme-alpine .ag-row {\n   background: #000 !important;\n }\n \n .bodythemedark .formbtn {\n   background-color: $addBtn-dark-blue;\n }\n \n .bodythemedark .formbtn:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .bodythemedark .resetbtn {\n   color: $white-color;\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n }\n \n \n .headingdark span {\n   background-color: $darkTheme_blue;\n }\n \n .resetbtn {\n   font-size: 16px !important;\n   font-weight: $font-semiBold !important;\n   border-radius: 5px !important;\n   background-color: transparent !important;\n   border: solid 1px $primary-color !important;\n   color: $primary-color !important;\n   min-width: 113px !important;\n }\n \n .resetbtn:hover,\n .resetbtn:active,\n .resetbtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n }\n \n .addBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n\n  .addDltBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n \n .addbtnlight {\n   background-color: $green-color;\n }\n \n .addbtndark {\n   background-color: $addBtn-dark-blue;\n }\n \n .addbtndark:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .formthemedark label {\n   color: $dark-light-blue;\n }\n \n \n .addBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: 2px;\n }\n \n .addBtn:hover {\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n }\n \n .cust_addBtn.addBtn svg {\n   top: 2px;\n }\n \n \n .deleteBtn {\n   min-width: 130px;\n   height: 50px;\n   background-color: $red-color;\n   color: $white-color;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n   border: none;\n }\n \n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .deleteBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: -2px;\n }\n \n .deleteBtn:hover,\n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color;\n   color: $white-color;\n   border: none;\n }\n \n .confirmBtn {\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  background-color: $primary-color !important;\n }\n\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .confirmBtn:hover,\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $darkTheme_darkBlue !important;\n }\n \n .confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n \n \n \n .delPopContainer .modal-body {\n   padding: 35px;\n   text-align: center;\n }\n \n .delPopContainer .delet_icon {\n   margin-bottom: 11px;\n }\n \n .delPopContainer p {\n   color: #131f43;\n   font-size: 14px;\n   font-weight: 700;\n   padding: 0 20px;\n }\n \n .arrowback svg {\n   fill: #000;\n }\n \n .bodythemedark .arrowback {\n   background-color: $backBtn-dark;\n   color: $dark-active-blue;\n }\n \n .bodythemedark .arrowback svg {\n   fill: $dark-active-blue;\n }\n \n .bodythemedark .drpdwn_btn {\n   background-color: $darkTheme_blue;\n }\n \n .bodythemedark .empname {\n   color: $dark-light-blue !important;\n }\n \n .bodythemedark .navitemli a {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingsgeneral,\n .bodythemedark .tabnavli a.settingslinks:hover {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingslinks {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a,\n .headerthemedark .dropdown_menu_contain .dropdown_item,\n .headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a:hover,\n .headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n }\n \n .dropdown_item:active {\n   background-color: $mainBg;\n }\n \n .profile_arrrow_dwn {\n   stroke: $darkTheme_blue;\n }\n \n .headerthemedark .profile_arrrow_dwn {\n   stroke: $white-color;\n }\n \n .dateinputbox1 input,\n .dateinputbox1 span {\n   color: $white-color !important;\n }\n \n /* LOGOUT MODAL */\n .modalStyleLight {}\n \n .modalStyleDark {}\n \n .delPopContainer .modal-content {\n   border-radius: 10px;\n   min-width: 399px;\n }\n \n .larg_model .modal-dialog {\n   max-width: 100% !important;\n }\n \n .larg_model .modal-content {\n   /* display: inline-block; */\n   height: 100%;\n   max-width: 900px;\n   margin: auto;\n   border-radius: 54px !important;\n   background: #FFF;\n   padding: 53px 53px 23px;\n }\n \n .larg_model .modal-header {\n   padding: 0px 0px 23px;\n   border-bottom: 1px dashed #D4D9EE;\n   display: block;\n }\n \n body .btn-primary:hover {\n   background-color: transparent;\n   border-color: #131F43;\n   color: #131F43;\n   fill: #131F43;\n   border: 1px solid;\n }\n \n .form-select {\n   display: block;\n   width: 100%;\n   padding: .375rem 2.25rem .375rem .75rem;\n   -moz-padding-start: calc(0.75rem - 3px);\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: #212529;\n   background-color: #fff;\n   background-image: url(../../assets/select_arow.svg) !important;\n }\n \n thead .CustomTable_tableheadlight__HuHZw th:first-child,\n thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n   border-radius: 5px 0 0 0px;\n   display: math;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n @media only screen and (max-width: 1200px) {\n   .tableheadlight th {\n     min-width: 170px;\n   }\n }\n \n @media only screen and (max-width: 1024px) {\n   .dashboard {\n     width: calc(100% - 50px) !important;\n     left: 50px !important;\n     padding: 10px 10px !important;\n     overflow-x: hidden;\n   }\n \n   .cont2 {\n     height: calc(100vh - 160px);\n     overflow-y: auto;\n   }\n }\n \n @media only screen and (max-width: 998px) {\n   /* #dashboardcont2{\n     height: auto !important;\n   }*/\n   /*.tableheadlight th {\n     min-width: 200px !important;\n   }*/\n }\n \n @media only screen and (max-width: 767px) {\n   .sectionright {\n     float: unset !important;\n   }\n .formthemelight {\n   padding: 10px 0!important;\n   box-shadow: none !important;\n }\n   .dashboard {\n     padding: 10px 10px !important;\n   }\n }\n \n @media only screen and (max-width: 600px) {\n   .cont2 {\n     width: $dashwidth !important;\n     left: $dashleft !important;\n     position: relative !important;\n     padding: 10px 10px 15px !important;\n   }\n \n   .bodythemelight,\n   .bodythemedark {\n     padding-top: 110px;\n   }\n \n   .delPopContainer .modal-content {\n     min-width: 100%;\n   }\n \n   .delPopContainer .modal-body {\n     padding: 15px;\n   }\n \n   .larg_model .modal-content {\n     border-radius: 20px !important;\n     padding: 22px;\n   }\n }\n \n @media (min-width: 576px) {\n   .exer_modal_contain .modal-dialog {\n     max-width: 1055px;\n   }\n \n   .delPopContainer .modal-dialog {\n     max-width: 350px;\n   }\n \n   /*.tableheadlight th {\n     min-width: 200px;\n   }*/\n }\n \n /* vk new changes */\n .active_show_outer {\n \n h2 {\n   color: var(--Font-black, #0B0D0F);\n   font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n   font-size: 22px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: normal;\n }\n \n   .active_show_inner {\n     width: 100%;\n     display: block;\n \n     .act_box_img {\n       margin-bottom: 12px;\n       min-height: 400px;\n       object-fit: cover;\n       overflow: hidden;\n       height: 400px;\n       max-height: 400px;\n       @media (max-width: 767px) {\n         min-height: 300px;\n         height: 300px;\n         max-height: 300px;\n       }\n       img {\n         max-height: 400px;\n         /* align-self: stretch; */\n         width: 100%;\n         height: 100%;\n         border-radius: 12px;\n         object-fit: cover;\n       }\n     }\n \n     .act_box_cnt {\n       width: 100%;\n       display: block;\n svg{\n  flex-shrink: 0;\n }\n       .act_box_bdg {\n         width: 100%;\n         margin-bottom: 12px;\n \n         span {\n           background: url(../../assets/ongoing.png) right top no-repeat;\n           width: 111px;\n           display: block;\n           height: 34px;\n           color: var(--White, #FFF);\n           font-size: 18px;\n           font-style: normal;\n           font-weight: 500;\n           padding: 3px 8px;\n         }\n \n         .sold {\n           background: url(../../assets/sold.png) right top no-repeat !important;\n         }\n \n       }\n \n       h3 {\n         color: var(--Secondary, #132941);\n         font-size: 18px;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 26.304px;\n         margin: 0;\n       }\n \n       p {\n         display: flex;\n         align-items: center;\n         gap: 10px;\n         margin-bottom: 5px;\n \n         span {\n           color: var(--Light-1, #736B66);\n           font-size: 14px;\n           font-style: normal;\n           font-weight: 500;\n           line-height: 26.304px;\n         }\n       }\n     }\n   }\n }\n \n /* vk new changes */\n .attent_details {\n   .attent_details_inner {\n     display: flex;\n     gap: 61px;\n     padding: 20px;\n     border-radius: 5px;\n     background: #FFF;\n     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n     align-items: center;\n \n     @media (max-width: 576px) {\n       display: block !important;\n     }\n \n     @media (max-width: 992px) {\n       display: flex;\n       gap: 20px;\n       align-items: start;\n     }\n \n     .attent_details_inner_l {\n       img {\n         width: 187px;\n         height: 207px;\n         flex-shrink: 0;\n         object-fit: contain;\n         @media screen and (max-width:767px) {\n          object-fit: contain;\n          width: auto;\n         }\n       }\n     }\n \n     .attent_details_inner_r {\n       flex: 1;\n \n       .attent_details_row {\n         display: flex;\n         gap: 20px;\n         margin-bottom: 28px;\n \n         @media (max-width: 992px) {\n           margin-bottom: 0px;\n           display: inline-block;\n           width: 100%;\n         }\n \n         .attent_details_row_box {\n           flex: 1;\n           width: 22%;\n \n           @media (max-width: 576px) {\n             margin: 15px 0px 10px !important;\n             width: 100% !important;\n           }\n \n           @media (max-width: 992px) {\n             margin-bottom: 15px;\n             float: left;\n             margin-right: 0;\n             width: 50%;\n             padding-right: 10px;\n           }\n \n           p {\n             margin-bottom: 10px;\n             color: #727272;\n             font-size: 13px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n           }\n \n           h5 {\n             color: #131F43;\n             font-size: 16px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n             word-wrap: break-word;\n           }\n         }\n       }\n \n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n     }\n   }\n }\n .showbox_sec {\n   display: grid;\n   grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n   gap: 20px;\n   align-items: stretch;\n   width: 100%;\n   @media screen and (max-width: 500px) {\n     grid-template-columns: 1fr;\n   }\n }\n .show_box_main {\n   margin: 10px 0px;\n   width: 100%;\n\n   .show_box {\n     min-height: 600px;\n     width: 100%;\n     margin-bottom: 0;\n     cursor: pointer;\n     display: flex;\n     flex-direction: column;\n     box-sizing: border-box;\n\n     @media (max-width: 767px) {\n       min-height: 500px;\n     }\n\n     .active_show_inner {\n       display: flex;\n       flex-direction: column;\n       flex: 1;\n       min-height: 0;\n     }\n\n     .act_box_img {\n       flex-shrink: 0;\n     }\n\n     .act_box_cnt {\n       flex: 1;\n       display: flex;\n       flex-direction: column;\n       min-height: 0;\n     }\n\n     img {\n       max-height: 400px;\n       height: 100%;\n       width: 100%;\n       object-fit: cover;\n\n       @media (max-width: 767px) {\n         max-height: 300px !important;\n       }\n     }\n\n     &:last-child {\n       margin-right: 0;\n     }\n   }\n \n   .no_show_box {\n     width: 350px;\n     margin: 0 auto 20px;\n     display: block;\n   \n     @media (max-width: 767px) {\n       width: 250px !important;\n     }\n   \n     img {\n       max-height: 450px;\n       height: 100%;\n       width: 100%;\n   \n       @media (max-width: 767px) {\n         max-height: 350px !important;\n       }\n     }\n     h6 {\n       color: #000;\n       text-align: center;\n       font-size: 26px;\n       font-style: normal;\n       font-weight: 700;\n       line-height: normal;\n       margin-top: 20px;\n       @media only screen and (max-width: 600px) {\n         font-size: 20px;\n       }\n     }\n   }\n   \n \n }\n \n .attent_flex {\n   justify-content: space-between !important;\n   gap: 30px;\n   align-items: center;\n \n   h5 {\n     font-size: 22px;\n     font-style: normal;\n     font-weight: 700;\n   }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `viewEvent_dashboard__lEdfy`,
	"dashboardContain": `viewEvent_dashboardContain__h15Id`,
	"bodythemedark": `viewEvent_bodythemedark__I+3nw`,
	"cont2": `viewEvent_cont2__Ms5ke`,
	"top_header": `viewEvent_top_header__4+BI6`,
	"top_header_inner": `viewEvent_top_header_inner__-y1Ms`,
	"subLink": `viewEvent_subLink__A2Vai`,
	"cst_vendr": `viewEvent_cst_vendr__VN2mH`,
	"form-control": `viewEvent_form-control__LT4ox`,
	"footer": `viewEvent_footer__vnKs+`,
	"bodythemelight": `viewEvent_bodythemelight__u4+Dx`,
	"headerthemelight": `viewEvent_headerthemelight__0NgEi`,
	"headerthemedark": `viewEvent_headerthemedark__asUPb`,
	"menuthemelight": `viewEvent_menuthemelight__3yTLe`,
	"menuthemedark": `viewEvent_menuthemedark__IQqKq`,
	"menulinklight": `viewEvent_menulinklight__qPYP2`,
	"menulinkdarkSelected": `viewEvent_menulinkdarkSelected__uGf4+`,
	"menulinklightSelected": `viewEvent_menulinklightSelected__QTbcs`,
	"menulinkdark": `viewEvent_menulinkdark__ncYbt`,
	"sub_arrow": `viewEvent_sub_arrow__Smu1l`,
	"headinglight": `viewEvent_headinglight__r7+86`,
	"headingdark": `viewEvent_headingdark__b4ZXE`,
	"searchboxlight": `viewEvent_searchboxlight__BxLpG`,
	"searchboxdark": `viewEvent_searchboxdark__3glrt`,
	"tableheadlight": `viewEvent_tableheadlight__58aYW`,
	"tableheaddark": `viewEvent_tableheaddark__JVL-i`,
	"table": `viewEvent_table__U2AOw`,
	"table-borderless": `viewEvent_table-borderless__elAYO`,
	"left-section": `viewEvent_left-section__8J6S5`,
	"tablebodylight": `viewEvent_tablebodylight__4K-7r`,
	"tablebodydark": `viewEvent_tablebodydark__5A4Xg`,
	"paginationlight": `viewEvent_paginationlight__UmLAp`,
	"paginationdark": `viewEvent_paginationdark__a3i+y`,
	"formthemelight": `viewEvent_formthemelight__Ze3nG`,
	"formthemedark": `viewEvent_formthemedark__lK6p8`,
	"viewformlight": `viewEvent_viewformlight__9gBFC`,
	"permissionboxlight": `viewEvent_permissionboxlight__526zJ`,
	"permissionboxdark": `viewEvent_permissionboxdark__NaGhX`,
	"errormsgclr": `viewEvent_errormsgclr__HepXq`,
	"graphclrlight": `viewEvent_graphclrlight__r6Y7z`,
	"graphclrdark": `viewEvent_graphclrdark__NVAn3`,
	"card1bglight": `viewEvent_card1bglight__7gbEw`,
	"card1bgdark": `viewEvent_card1bgdark__nHAD4`,
	"card2bglight": `viewEvent_card2bglight__V7isb`,
	"card2bgdark": `viewEvent_card2bgdark__JNW+M`,
	"card3bglight": `viewEvent_card3bglight__2JFl5`,
	"card3bgdark": `viewEvent_card3bgdark__+3cs1`,
	"card4bglight": `viewEvent_card4bglight__t9l8g`,
	"card4bgdark": `viewEvent_card4bgdark__DYPzQ`,
	"actionbtnlight": `viewEvent_actionbtnlight__sZC28`,
	"actionbtndark": `viewEvent_actionbtndark__QLqx7`,
	"profiledropdownlight": `viewEvent_profiledropdownlight__tJP78`,
	"profiledropdowndark": `viewEvent_profiledropdowndark__VyYZP`,
	"settingsection": `viewEvent_settingsection__j7OTM`,
	"addform": `viewEvent_addform__gATgO`,
	"savebtn": `viewEvent_savebtn__QUnQN`,
	"profile_conatiner": `viewEvent_profile_conatiner__RZB1y`,
	"ag-theme-alpine": `viewEvent_ag-theme-alpine__VBkF3`,
	"ag-row": `viewEvent_ag-row__5ucnN`,
	"formbtn": `viewEvent_formbtn__dnubP`,
	"resetbtn": `viewEvent_resetbtn__8NDLu`,
	"addBtn": `viewEvent_addBtn__qJCrv`,
	"addDltBtn": `viewEvent_addDltBtn__GQ0Rw`,
	"addbtnlight": `viewEvent_addbtnlight__Fqxsy`,
	"addbtndark": `viewEvent_addbtndark__z+pKv`,
	"cust_addBtn": `viewEvent_cust_addBtn__NfSL9`,
	"deleteBtn": `viewEvent_deleteBtn__tGdlm`,
	"confirmBtn": `viewEvent_confirmBtn__hEG5N`,
	"delPopContainer": `viewEvent_delPopContainer__j3pDN`,
	"modal-body": `viewEvent_modal-body__PvqU9`,
	"delet_icon": `viewEvent_delet_icon__305sr`,
	"arrowback": `viewEvent_arrowback__2wJEZ`,
	"drpdwn_btn": `viewEvent_drpdwn_btn__gy-bQ`,
	"empname": `viewEvent_empname__0qGA9`,
	"navitemli": `viewEvent_navitemli__DIy49`,
	"tabnavli": `viewEvent_tabnavli__KnpBi`,
	"settingsgeneral": `viewEvent_settingsgeneral__WJLSR`,
	"settingslinks": `viewEvent_settingslinks__eLEV2`,
	"dropdown_menu_contain": `viewEvent_dropdown_menu_contain__Swxik`,
	"dropdown_item": `viewEvent_dropdown_item__k9mVP`,
	"profile_arrrow_dwn": `viewEvent_profile_arrrow_dwn__qYEhf`,
	"dateinputbox1": `viewEvent_dateinputbox1__eupje`,
	"modal-content": `viewEvent_modal-content__CH-WW`,
	"larg_model": `viewEvent_larg_model__p-Gy0`,
	"modal-dialog": `viewEvent_modal-dialog__DOz8g`,
	"modal-header": `viewEvent_modal-header__9y8Rg`,
	"btn-primary": `viewEvent_btn-primary__wEfyw`,
	"form-select": `viewEvent_form-select__rTb5q`,
	"CustomTable_tableheadlight__HuHZw": `viewEvent_CustomTable_tableheadlight__HuHZw__m8nox`,
	"CustomTable_tableheaddark__nwqb4": `viewEvent_CustomTable_tableheaddark__nwqb4__3yjm7`,
	"sectionright": `viewEvent_sectionright__zJGop`,
	"exer_modal_contain": `viewEvent_exer_modal_contain__pclZV`,
	"active_show_outer": `viewEvent_active_show_outer__XgLgS`,
	"active_show_inner": `viewEvent_active_show_inner__HQ+G9`,
	"act_box_img": `viewEvent_act_box_img__-eKXd`,
	"act_box_cnt": `viewEvent_act_box_cnt__6WhE7`,
	"act_box_bdg": `viewEvent_act_box_bdg__EJEaV`,
	"sold": `viewEvent_sold__GFzmJ`,
	"attent_details": `viewEvent_attent_details__zziLG`,
	"attent_details_inner": `viewEvent_attent_details_inner__9JZ+Q`,
	"attent_details_inner_l": `viewEvent_attent_details_inner_l__F2KnX`,
	"attent_details_inner_r": `viewEvent_attent_details_inner_r__J0YYk`,
	"attent_details_row": `viewEvent_attent_details_row__Y7ygd`,
	"attent_details_row_box": `viewEvent_attent_details_row_box__V9sjX`,
	"attent_details_row_last": `viewEvent_attent_details_row_last__FEDGo`,
	"interesting_fact": `viewEvent_interesting_fact__uZktH`,
	"showbox_sec": `viewEvent_showbox_sec__T+Bw+`,
	"show_box_main": `viewEvent_show_box_main__nysLV`,
	"show_box": `viewEvent_show_box__cjhCz`,
	"no_show_box": `viewEvent_no_show_box__r2uLC`,
	"attent_flex": `viewEvent_attent_flex__JxOG9`,
	"eventcard_sec": `viewEvent_eventcard_sec__+PWKR`,
	"event_card_div": `viewEvent_event_card_div__ON38S`,
	"eventnamep": `viewEvent_eventnamep__xuh7y`,
	"electroh5": `viewEvent_electroh5__YFpBx`,
	"location": `viewEvent_location__9W739`,
	"gala": `viewEvent_gala__oLfHg`,
	"guild": `viewEvent_guild__K-lW7`,
	"copyclip": `viewEvent_copyclip__sfnNI`,
	"profile_view_container": `viewEvent_profile_view_container__mfwrE`,
	"eventcategorybox": `viewEvent_eventcategorybox__TSIdH`,
	"bg_icons_evnt": `viewEvent_bg_icons_evnt__2MbS6`,
	"sm_icon": `viewEvent_sm_icon__mxSJz`,
	"formbtncalloff": `viewEvent_formbtncalloff__SLOxt`,
	"formbtnedit": `viewEvent_formbtnedit__gtnuP`,
	"txt": `viewEvent_txt__A5qjW`,
	"vendorsty": `viewEvent_vendorsty__EmXW1`,
	"vendorssec": `viewEvent_vendorssec__ue23e`,
	"vendors_box": `viewEvent_vendors_box__ELQBK`
};
export default ___CSS_LOADER_EXPORT___;
